module.exports = __webpack_public_path__ + "static/media/store_black_24dp.9f1cdfde.svg";